import { render, staticRenderFns } from "./manage-facture-comment.html?vue&type=template&id=50008918&scoped=true&external"
import script from "./manage-facture-comment.js?vue&type=script&lang=js&external"
export * from "./manage-facture-comment.js?vue&type=script&lang=js&external"
import style0 from "./manage-facture-comment.scss?vue&type=style&index=0&id=50008918&prod&scoped=true&lang=scss&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50008918",
  null
  
)

export default component.exports